import { useState } from "react";
import { THEME_LABEL, applyTheme, loadTheme, nextTheme, saveTheme } from "./theme";

/** The mode switch: one button, three looks, no menu.
 *
 *  It is labelled with the mode it will switch you TO, not the one you are in.
 *  A button reading "Normal" while the archive is already normal reads as a
 *  status line, and you tap it expecting nothing to happen.
 *
 *  The state lives here and nowhere else. Changing a theme writes one attribute
 *  on <html> and the CSS custom properties do the rest -- nothing above this
 *  component re-renders, so switching modes does not touch a single one of the
 *  21,660 rows. It re-applies on mount as well as on click, so a remount after
 *  a reload lands on the stored mode rather than on whatever the markup last
 *  had.
 */
export function ThemeButton() {
  const [theme, setTheme] = useState(() => {
    const stored = loadTheme();
    applyTheme(stored);
    return stored;
  });
  const upcoming = nextTheme(theme);

  return (
    <button
      type="button"
      className="themebtn"
      aria-label={`switch to ${THEME_LABEL[upcoming]} mode`}
      onClick={() => {
        setTheme(upcoming);
        applyTheme(upcoming);
        saveTheme(upcoming);
      }}
    >
      {THEME_LABEL[upcoming]}
    </button>
  );
}
